import type { IUser } from "@bbj-types/user";
import type { IWorkshop, IWorkshopStatus } from "@bbj-types/workshop";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export type TCreateWorkshopsBody = Pick<IWorkshop, "sessionType" | "description" | "organizer" | "address"> & {
  convocationTimes?: Date[];
  date?: Date;
  startTime?: Date;
  endTime?: Date;
  supportCourse?: string;
  mainAnimator?: string;
  otherAnimators?: string[];
};
export interface IWorkshopCreateResponse
  extends Pick<
    IWorkshop,
    | "_id"
    | "sessionType"
    | "date"
    | "startTime"
    | "endTime"
    | "isDone"
    | "address"
    | "convocationTimes"
    | "description"
    | "organizer"
    | "participants"
  > {
  mainAnimator?: Pick<IUser, "_id" | "firstName" | "lastName" | "isDisabled">;
  otherAnimators: Pick<IUser, "_id" | "firstName" | "lastName" | "isDisabled">[];
  status: IWorkshopStatus;
}

export const usePostWorkshop = () => {
  const [state, execute, cancel] = workshopsAxios<IWorkshopCreateResponse, TCreateWorkshopsBody>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TCreateWorkshopsBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
